import { gql } from "@apollo/client";

const ISSUE_SUPPORT_TEMPLATE_FIELDS = `
  id
  planType
  name
  subject
  body
  description
  acceptsCustomText
  isActive
  createdAt
  updatedAt
`;

export const CREATE_ISSUE_SUPPORT_TEMPLATE = gql`
  mutation CreateIssueSupportTemplate($request: IssueSupportTemplateRequestInput!) {
    createIssueSupportTemplate(request: $request) {
      ${ISSUE_SUPPORT_TEMPLATE_FIELDS}
    }
  }
`;

export const UPDATE_ISSUE_SUPPORT_TEMPLATE = gql`
  mutation UpdateIssueSupportTemplate($id: UUID!, $request: IssueSupportTemplateRequestInput!) {
    updateIssueSupportTemplate(id: $id, request: $request) {
      ${ISSUE_SUPPORT_TEMPLATE_FIELDS}
    }
  }
`;

export const SET_ISSUE_SUPPORT_TEMPLATE_ACTIVE = gql`
  mutation SetIssueSupportTemplateActive($id: UUID!, $isActive: Boolean!) {
    setIssueSupportTemplateActive(id: $id, isActive: $isActive) {
      id
      isActive
    }
  }
`;

export const DELETE_ISSUE_SUPPORT_TEMPLATE = gql`
  mutation DeleteIssueSupportTemplate($id: UUID!) {
    deleteIssueSupportTemplate(id: $id)
  }
`;
